import LinkIcon from "@mui/icons-material/Link";
import { Card, Grid, Icon, IconButton, InputLabel, Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import MDPeriodo from "components/MDPeriodo";
import MDButton from "components/MDButton";
import MDModal from "components/MDModal";
import MDSelect from "components/MDSelect";
import MDTypography from "components/MDTypography";
import { useUser } from "context/UserContext";
import DataTable from 'examples/Tables/DataTable';
import { Form, Formik } from "formik";
import DefaultCell from "layouts/dashboards/sales/components/DefaultCell";
import PropTypes from "prop-types";
import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { toDate, toDateReqFormat, toDateTime } from "utils/DateUtils";
import { errorAlert, infoAviso, successAlert } from "utils/Functions";
import { post, postNoResponse } from 'utils/WebService';
import HistoryConsult from "views/history/HistoryConsult";
import MovimentationCreateEdit from "./MovimentationCreateEdit";

const MovimentationProcess = ({ id }) => {

    const [data, setData] = useState([]);
    const [pages, setPages] = useState(0);
    const [loadingTable, setLoadingTable] = useState(true);
    const [recordsTotal, setRecordsTotal] = useState(0);
    const [aplicar, setAplicar] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dados, setDados] = useState(null);
    const [header, setHeader] = useState(null);
    const [isCreateEdit, setIsCreateEdit] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [viewHistory, setViewHistory] = useState(false);


    const {
        fonteMovimentacaoEnum,
        tipoMovimentacaoEnum
    } = useUser();

    const fileInputRef = useRef(null);

    const tableState = useRef({
        pageSize: 10,
        pageIndex: 0,
        sorting: [],
        filtered: [],
        dataInicio: null,
        dataFim: null,
        tipoMovimentacao: null,
    });

    useEffect(() => {
        if (id) {
            fetchDataPeople({ ...tableState });
        }
    }, [id]);

    const columns = [
        {
            header: "data",
            accessorKey: "dataMovimentacao",
            cell: info => <DefaultCell>{toDate(info.getValue()) || '-'}</DefaultCell>,
            isSorted: true,
            width: "10%"
        },
        {
            header: "movimentação",
            accessorKey: "movimentacao",
            cell: info => <DefaultCell>{info.getValue() || ""}</DefaultCell>,
            isSorted: true,
            width: "30%"
        },
        {
            header: "Tipo de movimentação",
            accessorKey: "tipoMovimentacao",
            cell: info => {
                const status = tipoMovimentacaoEnum?.find(ht => ht.code === info.getValue())
                return (
                    <DefaultCell>{status?.name || ""}</DefaultCell>
                )
            },
            isSorted: true,
            width: "30%"
        },
        {
            header: "Criado em",
            accessorKey: "dataCriacao",
            cell: info => <DefaultCell>{toDateTime(info.getValue()) || '-'}</DefaultCell>,
            isSorted: true,
            width: "30%"
        },
        {
            header: "informação",
            accessorKey: "informacao",
            cell: info => {
                const dados = info.getValue();
                return (
                    (dados != null && dados?.length > 0) && (<IconButton
                        onClick={() => handleOpenModal(info.getValue(), 'Informações')}>
                        <MDTypography variant="h4">
                            <Icon color="inherit" sx={{ marginRight: 1 }}>description</Icon>
                        </MDTypography>
                    </IconButton>)
                )
            },
            isSorted: true,
            width: "10%"
        },
        {
            header: "Origem",
            accessorKey: "tipoFonte",
            cell: info => {
                const status = fonteMovimentacaoEnum?.find(ht => ht.code === info.getValue())
                return (
                    <DefaultCell>{status?.name || ""}</DefaultCell>
                )
            },
            isSorted: true,
            width: "10%"
        },
        {
            header: "link",
            isSorted: false,
            cell: info => {
                const link = info.row.original.link;

                return (
                    link != null && (
                        <Tooltip title="Abrir link">
                            <IconButton
                                onClick={() => window.open(link, "_blank")}
                                color="primary"
                            >
                                <LinkIcon />
                            </IconButton>
                        </Tooltip>
                    )
                )
            },
            width: "7%"
        },
        {
            header: "ações",
            isSorted: false,
            cell: info => (
                <>
                    <Tooltip title="Editar">
                        <IconButton
                            onClick={() => {
                                setSelectedId(info.row.original.id);
                                setIsCreateEdit(true);
                            }}>
                            <MDTypography variant="h4">
                                <Icon color="inherit" sx={{ marginRight: 1 }}>edit</Icon>
                            </MDTypography>
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Remover">
                        <IconButton
                            onClick={() => {
                                handleDelete(info.row.original.id);
                            }}>
                            <MDTypography variant="h4">
                                <Icon color="error" sx={{ marginRight: 1 }}>delete</Icon>
                            </MDTypography>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Log">
                        <IconButton
                            onClick={() => {
                                setSelectedId(info.row.original.id)
                                setViewHistory(true)
                            }}>
                            <MDTypography variant="h4">
                                <Icon color="inherit" sx={{ marginRight: 1 }}>search</Icon>
                            </MDTypography>
                        </IconButton>
                    </Tooltip>
                </>
            ),
            width: "15%"
        },
    ];

    const handleOpenModal = (dados, header) => {
        setDados(dados);
        setHeader(header);
        setIsModal(true);
    };

    const handleCloseModal = () => {
        setIsModal(false);
        setDados(null);
        setHeader(null);
    };

    const fetchDataPeople = useCallback(({ pageSize, pageIndex, sorting, filtered, dataInicio, dataFim, tipoMovimentacao }) => {
        setLoadingTable(true);

        const updatedTableState = {
            pageSize: pageSize ? pageSize : tableState.current.pageSize,
            pageIndex: (pageIndex == 0 || pageIndex) ? pageIndex : tableState.current.pageIndex,
            sorting: sorting ? sorting : tableState.current.sorting,
            filtered: (filtered && filtered.length > 0) ? filtered : tableState.current.filtered,
            dataInicio: dataInicio !== undefined ? dataInicio : tableState.current.dataInicio,
            dataFim: dataFim !== undefined ? dataFim : tableState.current.dataFim,
            tipoMovimentacao: tipoMovimentacao !== undefined
                ? (tipoMovimentacao ? (tipoMovimentacao.code !== undefined ? tipoMovimentacao.code : tipoMovimentacao) : null)
                : tableState.current.tipoMovimentacao,
        };
        tableState.current = updatedTableState;

        console.log("MovimentationProcess -> fetchDataPeople call:", {
            args: { pageSize, pageIndex, sorting, filtered, dataInicio, dataFim, tipoMovimentacao },
            updatedTableState,
            processoId: id
        });

        post("/processo-movimentacoes/list", {
            page: updatedTableState.pageIndex,
            pageSize: updatedTableState.pageSize,
            sorted: updatedTableState.sorting,
            filtered: updatedTableState.filtered,
            processoId: id,
            dataInicio: updatedTableState.dataInicio,
            dataFim: updatedTableState.dataFim,
            tipoMovimentacao: updatedTableState.tipoMovimentacao,

        }).then((res) => {
            console.log("MovimentationProcess -> API Response:", res);
            const { data, pages, recordsTotal } = res || {};
            setPages(pages || 0);
            setData(data || []);
            setRecordsTotal(recordsTotal || 0);
            setLoadingTable(false);
            setAplicar(false);
        }).catch((err) => {
            console.error("MovimentationProcess -> API Error:", err);
            setLoadingTable(false)
            setAplicar(false);
        });
    }, []);

    const handleDelete = (id) => {
        infoAviso(
            "Deseja realmente deletar essa movimentação do processo?",
            async () => {
                await removePerson(id);
            },
            () => {
                return;
            }
        );
    };

    const removePerson = async (id) => {
        if (id) {
            postNoResponse(`/movimentacao-processo/delete/${id}`)
                .then(() => {
                    successAlert("Movimentação removida com sucesso!", () => null);
                    fetchDataPeople({ ...tableState });
                })
                .catch(e => {
                    console.error(e)
                    errorAlert("Erro ao remover movimentação");
                })
        }
    }

    const backFunction = () => {
        setIsCreateEdit(false);
        setSelectedId(null);
        setViewHistory(false)
    }

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
            resolve(encoded);
        };
        reader.onerror = error => reject(error);
    });

    const handleImportClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = async (event) => {
        const files = Array.from(event.target.files);
        if (!files || files.length === 0) return;

        setLoadingTable(true);
        try {
            const requests = await Promise.all(files.map(async (file) => {
                const base64 = await toBase64(file);
                return {
                    base64File: base64,
                    nameFile: file.name
                };
            }));

            await postNoResponse("/movimentacao-processo/importar", requests);
            successAlert("Planilhas importadas com sucesso!", () => null);
            fetchDataPeople({ ...tableState });
        } catch (error) {
            console.error(error);
            errorAlert("Erro ao importar as planilhas");
        } finally {
            setLoadingTable(false);
            if (fileInputRef.current) {
                fileInputRef.current.value = null;
            }
        }
    };

    const handleRefresh = () => {
        fetchDataPeople({ ...tableState });
    };

    function handleAddPerson() {
        setIsCreateEdit(true);
        setSelectedId(null);
    };

    const handleApplyFilter = (values) => {
        fetchDataPeople({
            ...tableState, pageIndex: 0, dataInicio: values?.dataInicio, dataFim: values?.dataFim, tipoMovimentacao: values?.tipoMovimentacao,
        });
    };

    const handleCleanFilter = () => {
        let updatedTableState = {}
        setData([])
        updatedTableState = {
            pageSize: 10,
            pageIndex: 0,
            sorting: [],
            filtered: [],
            dataInicio: null,
            dataFim: null,
            tipoMovimentacao: null,
        };
        tableState.current = updatedTableState;
        fetchDataPeople({
            ...tableState
        });

    };

    return (
        <Card id="movimentation-process">
            {isModal &&
                <MDModal
                    header={header}
                    dados={dados}
                    show={isModal}
                    close={handleCloseModal}
                />
            }

            {isCreateEdit &&
                <Grid item xs={12} md={12}>
                    <MovimentationCreateEdit
                        id={selectedId}
                        closeCreateEdit={backFunction}
                        refreshTable={handleRefresh}
                        casoProcessualId={id} />
                </Grid>
            }

            {viewHistory &&
                <Grid item xs={12} md={12}>
                    <HistoryConsult
                        nomeEntidade="c045"
                        idEntidade={selectedId}
                        closeCreateEdit={backFunction} />
                </Grid>
            }

            <Grid item xs={12} md={12} sx={{ display: isCreateEdit || viewHistory ? "none" : "" }}>
                <MDBox p={2}>
                    <Formik
                        initialValues={{
                            dataInicio: null,
                            dataFim: null,
                            tipoMovimentacao: null,
                        }}
                        onSubmit={(values) => handleApplyFilter(values)}>
                        {({ values, setFieldValue, resetForm }) => {
                            return (
                                <Form>
                                    <Grid container spacing={2} pt={2}>
                                        <Grid item xs={6}>
                                            <MDPeriodo inicio={values.dataInicio} fim={values.dataFim}
                                                onChange={({ inicio, fim }) => { setFieldValue("dataInicio", inicio); setFieldValue("dataFim", fim); }} />
                                        </Grid>

                                        <Grid item xs={12} sm={3}>
                                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Tipo de Movimentação</InputLabel>
                                            <MDSelect
                                                getOptionValue={option => option.code}
                                                getOptionLabel={option => option.name}
                                                name="tipoMovimentacao"
                                                placeholder="Selecione o tipo de Movimentação"
                                                value={values.tipoMovimentacao}
                                                options={tipoMovimentacaoEnum}
                                                onChange={selectedOptions => {
                                                    setFieldValue('tipoMovimentacao', selectedOptions);
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} display='flex' justifyContent='space-between'>
                                            <Grid item xs={12} sm={12} textAlign="left">
                                                <MDButton
                                                    size="medium"
                                                    variant="contained"
                                                    color="info"
                                                    circular={false}
                                                    iconOnly={false}
                                                    onClick={handleAddPerson}
                                                >
                                                    Adicionar Movimentação
                                                </MDButton>

                                                <input
                                                    type="file"
                                                    multiple
                                                    accept=".xlsx, .xls, .csv"
                                                    style={{ display: "none" }}
                                                    ref={fileInputRef}
                                                    onChange={handleFileChange}
                                                />
                                                <MDButton
                                                    size="medium"
                                                    variant="contained"
                                                    color="info"
                                                    circular={false}
                                                    iconOnly={false}
                                                    onClick={handleImportClick}
                                                    style={{ marginLeft: 5 }}
                                                >
                                                    Importar recortes
                                                </MDButton>
                                            </Grid>

                                            <Grid item xs={12} sm={12} textAlign="right">
                                                <MDButton
                                                    size="medium"
                                                    sx={{ marginRight: 2 }}
                                                    variant="contained"
                                                    color="info"
                                                    circular={false}
                                                    iconOnly={false}
                                                    onClick={() => {
                                                        resetForm({
                                                            values: {
                                                                ...values,
                                                                dataInicio: null,
                                                                dataFim: null,
                                                            },
                                                        });
                                                        handleCleanFilter();
                                                    }}
                                                >
                                                    Limpar filtro
                                                </MDButton>
                                                <MDButton
                                                    size="medium"
                                                    variant="contained"
                                                    color="info"
                                                    circular={false}
                                                    iconOnly={false}
                                                    type="submit"
                                                >
                                                    Aplicar filtro
                                                </MDButton>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Form>
                            )
                        }}
                    </Formik>
                </MDBox>

                <MDBox p={2}>
                    <DataTable
                        loading={loadingTable}
                        columnData={columns}
                        data={data}
                        fetchData={fetchDataPeople}
                        totalPages={pages}
                        totalRecords={recordsTotal}
                        changeFilter={aplicar}
                        tableState={tableState} />
                </MDBox>
            </Grid>
        </Card>
    );
};

MovimentationProcess.propTypes = {
    id: PropTypes.string,
};

export default memo(MovimentationProcess);
